import config from '../../config/config';
import { formatDate } from '../sc-utilities'

export const getMediaArrays = files => {

    let tempImages = [];
    let tempVideos = [];
    let tempAudio = [];

    const mediaPath = `${config.backend_domain}:${config.backend_port}/static-media/`;

    const getMediaType = (file) => {
        return file.MIMEType.split('/')[0];
    };

    const getMediaPath = (file) => {
        let relativePath = '';
        if (file.RelativeFilePath) {
            relativePath = file.RelativeFilePath
        } else {
            relativePath = file.FilePath?.split(file.FilePath.includes('\\') ? '\\' : '/') ?? [];
            relativePath = relativePath.pop();
        }

        let path = mediaPath + relativePath;

        return path.replace(/\\/g, '/');
    };

    files.forEach((file) => {
        const type = getMediaType(file);
        if (type === 'image' && !file.Deleted) {
            tempImages.push({
                id: file.MediaID,
                path: getMediaPath(file),
                type: type,
                createdAt: file.CreatedAt ? formatDate(file.CreatedAt) : '',
            });
        }
        if (type === 'video' && !file.Deleted) {
            tempVideos.push({
                id: file.MediaID,
                path: getMediaPath(file),
                type: type,
                createdAt: file.CreatedAt ? formatDate(file.CreatedAt) : '',
            });
        }
        if (type === 'audio' && !file.Deleted) {
            tempAudio.push({
                id: file.MediaID,
                path: getMediaPath(file),
                type: type,
                createdAt: file.CreatedAt ? formatDate(file.CreatedAt) : '',
            });
        }
    });

    return { tempImages, tempVideos, tempAudio }
}
